module.exports = __webpack_public_path__ + "static/media/entopia.44d813ab.png";